var React = require('react');

function ContentParking (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"content-parking"),React.createElement("path",{"d":"M43,0a43,43,0,1,0,43,43A43,43,0,0,0,43,0Zm0,79.92a37,37,0,1,1,37-37A37,37,0,0,1,43,79.92Z","key":1}),React.createElement("path",{"d":"M48.77,18h-16a3,3,0,0,0-3,3V68.92a3,3,0,0,0,6,0V48h13a15,15,0,0,0,0-30Zm0,24h-13V24h13a9,9,0,1,1,0,18Z","key":2})]);
}

ContentParking.defaultProps = {"role":"presentation","viewBox":"0 0 85.92 85.92"};

module.exports = ContentParking;

ContentParking.default = ContentParking;
